import { ChangeEvent, useEffect, useState } from 'react'
import {
  getKlaviyoStatus,
  subscribeUserToKlaviyoList,
  unsubscribeUserFromKlaviyoList,
} from '../services/ClownApiClient'

type KlaviyoCheckboxProps = {}

export const KlaviyoCheckbox = ({}: KlaviyoCheckboxProps) => {
  const [profileIsSubscribed, setProfileIsSubscribed] = useState<boolean>(false)
  const [ongoingRequest, setongoingRequest] = useState<boolean>(false)
  const [showChangesSaved, setShowChangesSaved] = useState<boolean>(false)

  useEffect(() => {
    async function setInitialState() {
      const res = await getKlaviyoStatus()
      setProfileIsSubscribed(res.subscribed)
    }
    setInitialState()
  }, [])

  let timeout: NodeJS.Timeout
  async function handleCheckboxChange(e: ChangeEvent<HTMLInputElement>) {
    clearTimeout(timeout)
    setShowChangesSaved(false)
    setProfileIsSubscribed(e.target.checked)
    setongoingRequest(true)
    if (e.target.checked) {
      await subscribeUserToKlaviyoList()
    } else {
      await unsubscribeUserFromKlaviyoList()
    }
    setongoingRequest(false)
    setShowChangesSaved(true)
    timeout = setTimeout(() => setShowChangesSaved(false), 5000)
  }

  return (
    <div className="form-group form-check">
      <input
        id="checkbox-optin"
        className="form-check-input"
        type="checkbox"
        checked={profileIsSubscribed}
        onChange={handleCheckboxChange}
        disabled={ongoingRequest}
      />{' '}
      <label htmlFor="checkbox-optin" className="form-check-label">
        Receive e-mails related to products, account, information and news.
        <div
          className={`color-leaf ${
            showChangesSaved ? 'opacity-100' : 'fade-out'
          }`}>
          Your changes were saved!
        </div>
      </label>
    </div>
  )
}
